import React from 'react'
import { Link } from 'react-router-dom'

const Contact = () => {
    return (
        <div className='md:mb-8'>
            <div className='bg-gradient-to-r from-red-600 via-green-600 to-blue-600 rounded p-2 max-w-[1200px] mx-auto'>
            <div className='bg-gradient-to-br from-black to-[#084cab] rounded-none xl:rounded-md px-4 py-16 max-w-[1200px] text-left md:text-center mx-auto text-white'>
                <div className='max-w-[600px] mx-auto'>
                    <h5 className='text-3xl pb-4'>Limited Time Offer - First Month Free</h5>
                    <p className='text-lg pb-8'>With our current promotion, get a website designed and deployed for no startup cost. 1 Month trial period included.</p>
                    <Link to='/form' className='inline-flex text-lg md:text-xl font-semibold bg-[#3fc07c] hover:bg-white text-white hover:text-black py-2 px-4'>
                        Get Started
                    </Link>
                </div>
            </div>
            </div>
        </div>
    )
}

export default Contact